import React, { useEffect } from 'react';
import './App.css';
import './Privacy.css';
import './Careers.css';
import { ROLES } from './careersData';

function Careers() {
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    document.title = 'Careers | Walk It Off';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App">
      <nav className="nav">
        <a href="/" className="logo-container" aria-label="Walk It Off home">
          <img
            src="/walkitofflogo-dark.svg"
            alt="Walk It Off"
            className="logo-horizontal"
            width="350"
            height="130"
          />
        </a>
        <a href="https://apps.apple.com/us/app/walk-it-off-daily-walk-habit/id6818257483" className="nav-cta privacy-nav-cta" target="_blank" rel="noopener noreferrer">
          Download
        </a>
      </nav>

      <main className="privacy-page">
        <div className="privacy-container">
          <h1 className="privacy-title">Careers</h1>

          <h2>Who we are</h2>
          <p>
            Walk It Off is the accountability app that helps people build a daily walking habit and
            actually stick to it, including people walking for their heart health or blood sugar.
            Users set a daily step goal, track it automatically through Apple Health or Health
            Connect, and stay on track with streaks, challenges and friendly accountability.
          </p>
          <p>
            We're a small team, we ship fast, and bureaucracy is minimal. We make decisions with data:
            we test, measure and keep what works. Everyone owns their function end to end, and what
            you build reaches real people quickly.
          </p>
          <p>
            Working with us isn't for everyone. The pace is intense and you'll be building a lot from
            scratch. If that sounds like fun rather than a warning, read on.
          </p>

          <h2>Open roles</h2>
          <ul className="careers-role-list">
            {ROLES.map((role) => (
              <li key={role.id}>
                <a href={`/careers/${role.id}`}>{role.title}</a>
                <span className="careers-meta">{role.meta.join(' · ')}</span>
              </li>
            ))}
          </ul>

          <a href="/" className="privacy-back">← Back to Walk It Off</a>
        </div>
      </main>

      <footer className="footer">
        <div className="footer-bottom">
          <span>walkitoff.xyz</span>
          <span>© {currentYear} Walk It Off. All rights reserved.</span>
        </div>
      </footer>
    </div>
  );
}

export default Careers;
